import React, { useState } from "react";
import PageHeading from "../../components/PageHeading";
import { BackButton, HelpButton } from "../../components/btn/Buttons";
import Button from "../../components/btn/Button";
import Input from "../../components/inputs/Input";
import "./Dayreport.css";
import Table from "../../components/table/Table";
import { useSelector } from "react-redux";
import moment from "moment";
import { dayendHeaders } from "../../utils/data";
import store from "../../redux/store";
import { get_day_end_day_list } from "./DayendDaySlice";
import PageLoading from "../../components/PageLoading";

import { Switch } from "antd";
import { toast } from "react-toastify";
import { day_end_date_api } from "../../utils/apis";
import Loader from "../../components/Loader";
import RadioBtn from "../../components/radio/RadioBtn";
import { CheckBox } from "../../components/inputs/CheckBox";

const TransactionVerification = () => {
  const [verified, setVerified] = useState(true);
  const [date, setDate] = useState("");
  const [dateData, setDateData] = useState({});
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const { day_end_date } = useSelector((state) => state.profile);
  const [selectLink, setSelectLink] = useState([]);
  const [addDataHead, setAddDataHead] = useState([]);

  const { user_id } = useSelector((state) => state.other);
  const { last_transaction_verification_date, day_end_date_loading, day_end_date_list } = useSelector(
    (state) => state.day_end
  );

  useState(() => {
    setDateData({
      date: moment(day_end_date).format("YYYY-MM-DD"),
      fd: "",
      td: "",
    });
  }, [day_end_date]);

  const handle_update = async (type) => {
    try {
      setLoading(true);
      const body = new FormData();
      body.append("action", "updatedayendlist");
      body.append("agencyid", user_id);
      body.append("date", dateData?.date);
      body.append("type", type);

      addDataHead
        ?.filter((v, i) => v.flag == type)
        .forEach((val, ind) => {
          body.append("id[]", val?.id);
          body.append("status[]", val?.status);
          if (val?.st_flag) {
            body.append("STOCK_FLAG[]", val?.st_flag);
          } else if (val?.bt_flag) {
            body.append("BTFLAG[]", val?.bt_flag);
          }
        });
      const res = await day_end_date_api(body);
      if (res.success) {
        toast.success(res.message);
        const filterData = addDataHead?.filter((v, i) => v.flag != type);
        setAddDataHead(filterData);
        store.dispatch(
          get_day_end_day_list({
            ...dateData,
            verified,
            selectLink: selectLink,
          })
        );
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      console.log("error :", error);
    } finally {
      setLoading(false);
    }
  };

  // Columns that should be merged vertically across ALL rows
  const MERGE_COLUMNS = [
    "ONLINE_AMOUNT",
    "CASH_AMOUNT",
    "BANK_NAME",
    "TRANSACTION_ID",
  ];

  return (
    <div className="container">
      <PageHeading
        title={"Transaction Verification"}
        right={
          <>
            <Button
              title={!verified ? "ALL" : "UN-VERIFIED"}
              onClick={() => {
                setVerified(!verified);
                setDateData({});
                setSelectLink([]);
                setShow(false);
              }}
            />
            <BackButton />

            <HelpButton
              link={[
                "https://youtu.be/oEzSuwSIkRg",
                "https://youtu.be/rrX-pqA7h68",
              ]}
            />
          </>
        }
      />
      <div style={{ height: "20px" }}></div>
      <div>
        {verified ? (
          <p className="DayEndText">
            LAST Transaction Verification SUBMITTED DATE :{" "}
            <b>
              {last_transaction_verification_date
                ? moment(
                  last_transaction_verification_date,
                  "DD-MM-YYYY"
                ).format("DD-MMM-YYYY")
                : "-"}
            </b>
          </p>
        ) : (
          dateData?.fd &&
          dateData?.td && (
            <p className="DayEndText">
              Selected Dates{" "}
              {dateData?.fd && <b> From : {dateData?.fd}</b>}
              {dateData?.td && <b> To : {dateData?.td}</b>}
            </p>
          )
        )}
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "flex-end",
          gap: "20px",
          marginTop: "1rem",
          alignItems: "center",
        }}
      >
        {verified ? (
          <>
            <Input
              mw={"150px"}
              type={"date"}
              max={moment(new Date()).format("YYYY-MM-DD")}
              value={dateData?.date}
              disabled={loading || day_end_date_loading}
              onChange={(e) => {
                if (e.target.value.length <= 10) {
                  setDateData((prev) => ({
                    ...prev,
                    date: e.target.value,
                  }));
                }
              }}
            />
          </>
        ) : (
          <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
            <lable style={{ minWidth: "50px" }}>From :</lable>
            <Input
              mw={"150px"}
              type={"date"}
              value={dateData?.fd}
              max={moment(new Date()).format("YYYY-MM-DD")}
              disabled={loading || day_end_date_loading}
              onChange={(e) => {
                if (e.target.value.length <= 10) {
                  setDateData((prev) => ({
                    ...prev,
                    fd: e.target.value,
                  }));
                }
              }}
            />
            <lable style={{ minWidth: "30px" }}>To :</lable>
            <Input
              mw={"150px"}
              type={"date"}
              value={dateData?.td}
              max={moment(new Date()).format("YYYY-MM-DD")}
              disabled={loading || day_end_date_loading}
              onChange={(e) => {
                if (e.target.value.length <= 10) {
                  setDateData((prev) => ({
                    ...prev,
                    td: e.target.value,
                  }));
                }
              }}
            />
          </div>
        )}
        <div
          style={{
            display: "flex",
            gap: "15px",
            flexWrap: "wrap",
          }}
        >
          <RadioBtn label={"Select List's "} />
          {dayendHeaders.map((v, i) => (
            <CheckBox
              key={i}
              disabled={loading || day_end_date_loading}
              lable={v?.id?.split("_").join(" ")?.toUpperCase()}
              Checked={selectLink?.includes(i + 1)}
              value={selectLink?.includes(i + 1)}
              onChange={() => {
                const data = selectLink?.filter((v) => v === i + 1);
                const data2 = selectLink?.filter((v) => v !== i + 1);
                if (data?.length > 0) {
                  setSelectLink(data2);
                } else {
                  setSelectLink([...selectLink, i + 1]);
                }
              }}
            />
          ))}
        </div>
        <Button
          disable={
            selectLink?.length == 0 ||
            (!verified ? !dateData?.fd || !dateData?.td : !dateData?.date) ||
            loading ||
            day_end_date_loading
          }
          title={"GENERATE"}
          onClick={async () => {
            setLoading(true);
            await store.dispatch(
              get_day_end_day_list({
                ...dateData,
                verified,
                selectLink: selectLink,
              })
            );
            setShow(true);
            setLoading(false);
          }}
        />
      </div>
      {show &&
        (day_end_date_loading || loading ? (
          <PageLoading />
        ) : (
          <div>
            {dayendHeaders?.map((v, i) => (
              <div className="mt10" key={i}>
                {day_end_date_list?.[v?.id]?.length > 0 && (
                  <>
                    <p className="DayEndText mt10">
                      {v?.id?.split("_").join(" ").toUpperCase()} DETAILS
                    </p>

                    <Table
                      mt={5}
                      headData={Object.values(v?.data)}
                      body={day_end_date_list?.[v?.id].map((val, ind, arr) => {
                        // Total number of rows in the table
                        const totalRows = arr.length;

                        // This is the first row (index 0)
                        const isFirstRow = ind === 0;

                        return (
                          <tr key={ind}>
                            {/* Render all data columns except STATUS */}
                            {Object.keys(v?.data)
                              .slice(0, -1)
                              .map((key, index) => {
                                const isMergeColumn =
                                  MERGE_COLUMNS.includes(key);

                                // For merge columns, only render on the FIRST row
                                if (isMergeColumn && !isFirstRow) {
                                  return null;
                                }

                                return (
                                  <td
                                    key={index}
                                    rowSpan={isMergeColumn ? totalRows : 1}
                                    style={
                                      isMergeColumn
                                        ? {
                                          verticalAlign: "middle",
                                          textAlign: "center",
                                        }
                                        : {}
                                    }
                                  >
                                    {val?.[key] || "-"}
                                  </td>
                                );
                              })}
                            {/* STATUS column - only show on first row and span all rows */}
                            {/* {isFirstRow && ( */}

                            <td>
                              {val?.STATUS_FLAG ? (
                                "Verified"
                              ) : (
                                <Switch
                                  disabled={val?.STATUS_FLAG}
                                  checked={
                                    val?.STATUS_FLAG ||
                                      addDataHead?.filter(
                                        (s) => s?.id == val?.ID
                                      )?.[0]?.status
                                      ? true
                                      : false
                                  }
                                  onChange={(check) => {
                                    const filterData = addDataHead?.filter(
                                      (s) => s?.id == val?.ID
                                    );
                                    const filterDataWithout =
                                      addDataHead?.filter(
                                        (s) => s?.id != val?.ID
                                      );
                                    if (filterData?.length == 0) {
                                      setAddDataHead([
                                        ...addDataHead,
                                        {
                                          id: val?.ID,
                                          status: check,
                                          flag: v?.id,
                                          st_flag: val?.STOCK_FLAG
                                            ? val?.STOCK_FLAG
                                            : "",
                                          bt_flag: val?.BTFLAG
                                            ? val?.BTFLAG
                                            : "",
                                        },
                                      ]);
                                    } else if (filterData?.length > 0) {
                                      setAddDataHead(filterDataWithout);
                                    }
                                  }}
                                />
                              )}
                            </td>
                            {/* <td
                              // rowSpan={totalRows}
                              style={{
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              {val?.STATUS_FLAG ? (
                                "Verified"
                              ) : (
                                <Switch
                                  disabled={val?.STATUS_FLAG}
                                  checked={
                                    val?.STATUS_FLAG ||
                                    addDataHead?.some(
                                      (s) =>
                                        s?.id === val?.ID &&
                                        s?.module === val?.TRANS_ID
                                    )
                                  }
                                  onChange={(check) => {
                                    const isPresent = addDataHead?.some(
                                      (s) =>
                                        s?.id === val?.ID &&
                                        s?.module === val?.TRANS_ID
                                    );

                                    if (!isPresent) {
                                      setAddDataHead([
                                        ...addDataHead,
                                        {
                                          id: val?.ID,
                                          status: check,
                                          flag: v?.id,
                                          st_flag: val?.STOCK_FLAG || "",
                                          bt_flag: val?.BTFLAG || "",
                                          module: val?.TRANS_ID || "",
                                        },
                                      ]);
                                    } else {
                                      setAddDataHead((prev) =>
                                        prev.filter(
                                          (s) =>
                                            !(
                                              s?.id === val?.ID &&
                                              s?.module === val?.TRANS_ID
                                            )
                                        )
                                      );
                                    }
                                  }}
                                />
                              )}
                            </td> */}
                            {/* )} */}
                          </tr>
                        );
                      })}
                    />

                    {/* SUBMIT BUTTON */}
                    {addDataHead?.some((vals) => vals?.flag === v?.id) && (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          margin: "1.5rem 0",
                        }}
                      >
                        <Button
                          title="SUBMIT"
                          onClick={() => handle_update(v?.id)}
                        />
                      </div>
                    )}
                  </>
                )}
              </div>
            ))}
          </div>
        ))}
      {loading && !show && <Loader loading={loading && !show} />}
    </div>
  );
};

export default TransactionVerification;
